import styled from 'styled-components';

export const H1 = styled.h1`
  font-size: 38px;
`;

export const H2 = styled.h2`
  font-size: 34px;
`;



// WEBPACK FOOTER //
// ./src/elements/Headings.js